import { render } from "./UserApiCreate.vue?vue&type=template&id=20892e20"
import script from "./UserApiCreate.vue?vue&type=script&lang=js"
export * from "./UserApiCreate.vue?vue&type=script&lang=js"

import exportComponent from "/home/leandro/trabalho-timo/kuhlenbier-web-frontend-partner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__